<ng-container *ngIf="selected as current">
  <button
    #triggerBtn
    type="button"
    class="day-toggle"
    [class.day-toggle--interactive]="hasMultiple"
    (click)="onTriggerClick($event)"
  >
    <span class="day-toggle__label">{{ current.label }}</span>
    <img
      *ngIf="current.hasCarryOver"
      src="assets/images/icons/svg/carryover_moon-filled.svg"
      alt="Carryover"
      class="day-toggle__carryover"
    />
    <i *ngIf="hasMultiple" class="fa fa-chevron-down day-toggle__caret" aria-hidden="true"></i>
  </button>

  <p-overlayPanel
    #op
    [appendTo]="'body'"
    styleClass="day-toggle-overlay"
    (onShow)="centerOverlay(triggerBtn)"
  >
    <div class="day-toggle-options">
      <button
        *ngFor="let variant of variants"
        type="button"
        class="day-toggle-option"
        [class.day-toggle-option--selected]="variant.id === current.id"
        (click)="onSelect(variant)"
      >
        <span class="day-toggle-option__label">{{ variant.label }}</span>
        <img
          *ngIf="variant.hasCarryOver"
          src="assets/images/icons/svg/carryover_moon-filled.svg"
          alt="Carryover"
          class="day-toggle-option__carryover"
        />
      </button>
    </div>
  </p-overlayPanel>
</ng-container>
